export function initSrcLazyLoad() {
    function lazyLoad() {
        const elements = document.querySelectorAll('img[data-src], iframe[data-src]');
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const viewportBottom = window.innerHeight + scrollTop;

        elements.forEach(el => {
            const dataSrc = el.getAttribute('data-src');
            if (dataSrc !== '') {
                const offsetTop = el.getBoundingClientRect().top + scrollTop;
                if (offsetTop - 100 < viewportBottom) {
                    el.src = dataSrc;
                    el.removeAttribute('data-src');

                    const dataSrcset = el.getAttribute('data-srcset');
                    if (dataSrcset) {
                        el.srcset = dataSrcset;
                        el.removeAttribute('data-srcset');
                    }
                }
            }
        });
    }

    window.addEventListener('scroll', lazyLoad);
    window.addEventListener('load', lazyLoad);
}
